import { render } from "./PollForm.vue?vue&type=template&id=476f8598&scoped=true"
import script from "./PollForm.vue?vue&type=script&lang=js"
export * from "./PollForm.vue?vue&type=script&lang=js"

import "./PollForm.vue?vue&type=style&index=0&id=476f8598&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-476f8598"]])

export default __exports__